<template>
  <div class="c-bmi">
    <div class="line-container">
      <div class="line-content"> </div>
      <div class="cur" :style="{ left: (curIndex / list.length) * 100 + '%' }">
        <div class="flag">
          <div class="flag-num"
            ><span class="flag-text">BMI: </span>{{ data }}</div
          >
        </div>
      </div>
    </div>
    <div class="text-content">
      <div class="text-item" v-for="(item, index) in list" :key="index">
        <div
          class="text1"
          :style="{ color: curIndex == index ? item.color : 'rgba(0,0,0,0.5)' }"
          >{{ item.text }}</div
        >
        <div class="text2">{{ item.numtext }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      list: [
        {
          color: '#E97080',
          text: '偏瘦',
          numtext: '≤18.5',
          min: 10,
          max: 18.5
        },
        {
          color: '#6C51F4',
          text: '理想',
          numtext: '18.5 - 24',
          min: 18.5,
          max: 24
        },
        {
          color: '#E97080',
          text: '偏胖',
          numtext: '24 - 28',
          min: 24,
          max: 28
        },
        {
          color: '#E97080',
          text: '肥胖',
          numtext: '>28',
          min: 28,
          max: 40
        }
      ]
    }
  },
  computed: {
    cur() {
      if (!this.data) {
        return '0%'
      }
      let res
      let data = this.data
      let everyItem = 1 / this.list.length //每一个范围的bmi占多少百分比
      let curIndex = -1 //在哪个位置
      this.list.map((item, index) => {
        if (data > item.min && data <= item.max) {
          curIndex = index
        }
      })
      if (curIndex < 0) {
        //表示bmi在所有范围之外
        res = data < this.list[0].min ? 0 : 1
      } else {
        res =
          (curIndex +
            (data - this.list[curIndex].min) /
              (this.list[curIndex].max - this.list[curIndex].min)) *
          everyItem
      }
      return res * 100 + '%'
    },
    curIndex() {
      let data = this.data
      let curIndex = -1 //在哪个位置
      this.list.map((item, index) => {
        if (data > item.min && data <= item.max) {
          curIndex = index
        }
      })
      if (curIndex < 0) {
        //表示bmi在所有范围之外
        curIndex = data < this.list[0].min ? 0 : this.list.length - 1
      }
      return curIndex
    }
  }
}
</script>
<style lang="scss" scoped>
.c-bmi {
  padding-top: 36px;

  .line-container {
    position: relative;
    margin-bottom: 8px;

    .line-content {
      height: 7px;
      background: rgba(0, 0, 0, 0.09);
      border-radius: 4px;
    }

    .cur {
      width: 25%;
      position: absolute;
      height: 7px;
      background: #8672ff;
      border-radius: 4px;
      left: 0;
      top: 0;
    }

    .flag {
      position: absolute;
      width: 0;
      height: 0;
      left: 50%;
      transform: translate(-50%);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 8px solid #171d33;
      transition: left 0.3s ease;
      bottom: 14px;

      .flag-num {
        width: 72px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 20px;
        z-index: 2;
        position: absolute;
        left: 0;
        bottom: 6px;
        transform: translate(-50%);
        color: #fff;
        border-radius: 4px;
        background: #171d33;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;

        .flag-text {
          font-size: 12px;
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC;
        }
      }
    }
  }

  .text-content {
    display: flex;

    .text-item {
      flex: 1;
      text-align: center;

      .text1 {
        font-size: 10px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.5);
        line-height: 16px;
      }

      .text2 {
        font-size: 10px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.3);
        line-height: 16px;
      }
    }

    .text-item-active {
    }
  }
}
</style>
